import React from "react";

import {
    Stack,
    Skeleton,
    Stepper,
    StepButton,
    StepContent,
    Step,
    Paper,
} from "@mui/material";

const StepperSkeleton = () => {
    const fontSize = "1.5rem";
    return (
        // Map the phases
        <Stepper nonLinear orientation="vertical">
            <Step key={"opstart"}>
                <StepButton disabled>
                    <Skeleton
                        width={50}
                        variant="text"
                        sx={{ fontSize: fontSize }}
                    />
                </StepButton>
                <StepContent>
                    <Stepper nonLinear orientation="vertical">
                        {[1, 2, 3, 4, 5].map((step) => (
                            <Step key={step}>
                                <StepButton>
                                    <Skeleton
                                        width={100}
                                        variant="text"
                                        sx={{ fontSize: fontSize }}
                                    />
                                </StepButton>
                            </Step>
                        ))}
                    </Stepper>
                </StepContent>
            </Step>
            <Step>
                <StepButton>
                    <Skeleton
                        width={100}
                        variant="text"
                        sx={{ fontSize: fontSize }}
                    />
                </StepButton>
            </Step>
        </Stepper>
    );
};

export default function ProjectSkeleton() {
    const fontSizes ={ 
        header: "4rem",
        textField: "2.5rem"
    }
    return (
        <>
            <Stack
                direction="row"
                spacing={2}
                minWidth={"min-content"}
            >
                <Stack component={Paper}>
                    <Skeleton variant="rectangular" width={250} height={30} />
                    <StepperSkeleton />
                </Stack>
                <Paper>
                    <Stack
                        justifyContent={"space-between"}
                        // sx={{ width: "100%" }}
                    >
                        <Skeleton variant="text" sx={{fontSize: fontSizes.header}} width={300} />
                        <Skeleton variant="text" sx={{fontSize: fontSizes.textField}}/>
                        <Skeleton
                            variant="rectangular"
                            width={800}
                            height={100}
                        />
                        <Skeleton variant="text" sx={{fontSize: fontSizes.textField}}/>
                        <Skeleton variant="text" sx={{fontSize: fontSizes.textField}}/>
                        <Skeleton variant="text" sx={{fontSize: fontSizes.textField}}/>
                        <Skeleton variant="text" sx={{fontSize: fontSizes.textField}}/>
                    </Stack>
                </Paper>
            </Stack>
        </>
    );
}
